<div class="container-fluid">
  <div class="row">
    <div class="col-md-12">

      <!-- input element with eventual search button -->
      <div class="input-group input-group-sm">
        <input #Input type="text" class="form-control {{inputStyleClass}} {{customInputClass}}" [attr.aria-label]="'NameOrBusinessName'|trad" aria-describedby="basic-addon2" autocomplete="off"
               [placeholder]="inputPlaceHolder"
               [ngModel]="inputContentText | showValueSeparat:'|':1"
               (ngModelChange)="inputContentText=$event"
               (keyup)="search($event)"
               (keydown)="getArrowKeys($event)"
               [disabled]="isDisabled">
        
        <div class="input-group-append" *ngIf="inputWithButton" >
          <button class="btn btn-outline-secondary" type="button" (click)="search($event)" [disabled]="isDisabled">
            <i class="fas fa-binoculars"></i>
          </button>
        </div>
        <div class="input-group-append" *ngIf="inputWithDelete">
          <button class="btn btn-outline-secondary trashbtn" type="button" (click)="cleanInput()" [disabled]="isDisabled">
            <i class="fas fa-trash-alt"></i>
          </button>
        </div>
      </div>

      <!-- list element with search results -->
      <div *ngIf="showList" class="listResult {{listStyleClass}}" [style.minWidth.px]="Input.clientWidth">
        <ul class="list-unstyled">
          <li *ngFor="let item of list" (click)="selectItem(item)"
              [title]="item.Text"
              class="q-hover"
              style=" white-space: nowrap; text-overflow: ellipsis; width: 100%; overflow: hidden;">
            <span>{{item.Text}}</span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>
